import LocalizedStrings from "react-localization";
import { SearchField } from "@aws-amplify/ui-react";
import { SimpleTreeView } from "@mui/x-tree-view/SimpleTreeView";
import { TreeItem } from "@mui/x-tree-view";

const CompaniesTree = ({
  tree,
  onSelectAll,
  onSelectCompany,
  onSelectBranch,
  onSelectDevice,
  onSearchSubmit,
}) => {
  return (
    <>
      <SearchField
        label="Search"
        className="mb-2"
        placeholder={strings.search.placeholder}
        onSubmit={onSearchSubmit}
        onClear={onSearchSubmit}
      />
      <SimpleTreeView defaultExpandedItems={["companyAll"]}>
        <TreeItem
          itemId="companyAll"
          label={strings.companies}
          onClick={onSelectAll}
        >
          {tree?.map((item) => (
            <TreeItem
              itemId={`company-${item.id}`}
              label={
                <span>
                  {item.name} {item.alerts?.length > 0 && item.alerts}
                </span>
              }
              onClick={() => onSelectCompany(item.id)}
            >
              {item.branches?.map((branchItem) => (
                <TreeItem
                  itemId={`branch-${branchItem.id}`}
                  label={
                    <span>
                      {branchItem.name}{" "}
                      {branchItem.alerts?.length > 0 && branchItem.alerts}
                    </span>
                  }
                  onClick={() => onSelectBranch(branchItem.id, item.id)}
                >
                  {branchItem.devices?.map((deviceItem) => (
                    <TreeItem
                      itemId={`device-${deviceItem.id}`}
                      label={
                        <span>
                          {deviceItem.name}{" "}
                          {deviceItem.alerts?.length > 0 && deviceItem.alerts}
                        </span>
                      }
                      onClick={() => onSelectDevice(deviceItem.id)}
                    />
                  ))}
                </TreeItem>
              ))}
            </TreeItem>
          ))}
        </TreeItem>
      </SimpleTreeView>
    </>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Alertas",
    search: {
      placeholder: "Buscar...",
      noResults: "No hay resultados",
    },
    responses: {
      errorFetch: "Error al consultar datos",
    },
    companies: "Empresas",
    recognize: "Reconocer",
    activatedAt: "Fecha activado",
    recognizedAt: "Fecha reconocido",
    successRecognized: "Alerta reconocida con éxito",
    filters: {
      status: "Estado",
      user: "Usuario quien reconoce",
      activatedAt: "Fecha activado",
      recognizedAt: "Fecha reconocido",
    },
    status: {
      activated: "Activado",
      recognized: "Reconocido",
    },
  },
});

export default CompaniesTree;
